export default {"src":"/_next/static/media/deno.2e2b830f.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};